<template>
  <div class="intro-container">
    <img class="border-left" src="../assets/brand_photos/mobile1.png" alt="brand image 1">
    <div class="text-box1">
      <div class="text">
        <p>A FOKOS 21 pengéjé és markolata egyetlen nagyszilárdságú rozsdamentes krómacél lemezből készül, ezáltal a markolat rendkívül ellenálló, de mégis képes elnyelni a csapások keltette rezgéseket.</p>
      </div>
    </div>
    <div class="image-box1"><div id="image1"></div></div>
    <div class="image-box2"><div id="image2"></div></div>
    <img class="border-right" src="../assets/brand_photos/mobile2.png" alt="brand image 2">
    <div class="text-box2">
      <div class="text">
        <p>A fejrészen a vágó él elsődlegesen vágásra és hasításra, az ék pedig a maximális zúzóerő kifejtésére lett kialakítva.</p>
      </div>
    </div>
    <img class="border-left" src="../assets/brand_photos/mobile3.png" alt="brand image 3">
    <div class="text-box3">
      <div class="text">
        <p>Használható vágásra, hasításra, törésre, szúrásra, feszítésre, szélvédő áttörésére, csavarhúzásra és még rengeteg mindenre.</p>
      </div>
    </div>
    <div class="image-box3"><div id="image3"></div></div>
  </div>
</template>

<script>
export default {
  name: "CleanIntro"
}
</script>

<style scoped>
  .intro-container {
      display: grid;
      height: 140vw;
      padding: 50px 0;
      background: url(../assets/background_elements/bgpattern.png) no-repeat top;
      background-size: cover;
  }

  p {
    font-weight: 500;
    font-size: min(calc(10px + 1vw), 30px);
    line-height: 175%;
  }

  img {
    display: none;
  }

  .text-box1 {
    padding-right: 30px;
    padding-left: 10vw;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    grid-column: 1/6;
    grid-row: 1/4;
    overflow: hidden;
  }

  .image-box1 {
    padding-left: calc(-100px + 10vw);
    padding-top: calc(-100px + 10vw);
    padding-bottom: calc(-100px + 10vw);
    grid-column: 6/11;
    grid-row: 1/5;
  }

  .image-box2 {
    padding-right: calc(-100px + 10vw);
    padding-top: calc(-100px + 10vw);
    padding-bottom: calc(-100px + 10vw);
    grid-column: 1/6;
    grid-row: 4/10;
  }

  .text-box2 {
    padding-left: 50px;
    padding-right: 10vw;
    display: flex;
    align-items: center;
    grid-column: 6/11;
    grid-row: 5/9;
    overflow: hidden;
  }

  .text-box3 {
    padding-right: 30px;
    padding-left: 10vw;
    display: flex;
    align-items: start;
    justify-content: flex-end;
    grid-column: 1/6;
    grid-row: 10/13;
    overflow: hidden;
  }

  .image-box3 {
    padding-left: calc(-100px + 10vw);
    padding-top: calc(-50px + 10vw);
    padding-bottom: calc(-50px + 10vw);
    grid-column: 6/11;
    grid-row: 9/13;
  }

  .text {
    max-width: 700px;
  }

  #image1 {
    width: 100%;
    height: 100%;
    background-image: url("../assets/brand_photos/desktop1.png");
    background-position: top left;
    background-repeat: no-repeat;
    background-size: cover;
  }

  #image2 {
    width: 100%;
    height: 100%;
    background-image: url("../assets/brand_photos/desktop2.png");
    background-position: top right;
    background-repeat: no-repeat;
    background-size: cover;
  }

  #image3 {
    width: 100%;
    height: 100%;
    background-image: url("../assets/brand_photos/desktop3.png");
    background-position: left center;
    background-repeat: no-repeat;
    background-size: cover;
  }

  @media only screen and (max-width: 700px) {
    .intro-container {
      display: flex;
      flex-direction: column;
      height: auto;
    }

    .text-box1, .text-box2, .text-box3 {
      padding: 0 7vw;
    }

    p {
      font-size: 20px;
      line-height: 200%;
      font-weight: normal;
    }

    img {
      display: inline-block;
      margin: 75px 0;
      width: auto;
    }

    .border-left {
      border-left: 40px solid transparent;
    }

    .border-right {
      border-right: 40px solid transparent;
    }
  }
</style>
